"use client";

import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Container, Message, Text } from "@huub-web/ui";

interface ErrorScreenProps {
  debugInfo?: string;
  title?: string;
  body?: ReactNode;
}

/**
 * The ErrorScreen component is used to display an error message to the user.
 */
export const ErrorScreen: FC<ErrorScreenProps> = ({
  title,
  body,
  debugInfo,
}) => {
  const { t } = useTranslation();

  return (
    <Container size="s">
      {title && <Text variant="displayM">{title}</Text>}
      <Message variant="error" body={body ?? t("general.error")} />
      {debugInfo && (
        <Text variant="surfaceSubtitle" color="defaultBorder">
          {debugInfo}
        </Text>
      )}
    </Container>
  );
};
